export default "__VITE_ASSET__dbd75e9c__"